import { Box } from '@mui/material';
import CombinationCard from './CombinationCard4';

export default function CombinationCompareGrid({
  combinations,
  furniturePieces,
  selectedId,
  onSelect,
  onTry,
  onMoveUp,
  onMoveDown,
}) {
  return (
    <Box sx={{ mb: 2 }}>
      {/*
        Each card is capped at a natural, comfortable width (340px) instead
        of being allowed to grow to fill the row. `auto-fill`
        keeps any unused columns as real (empty) tracks instead of
        collapsing them into the populated ones, and `justifyContent:
        'start'` keeps the populated cards left-aligned rather than
        centered or stretched -- so one card, three cards, or six cards
        all render at the same natural size and just take up more or less
        of the row.
      */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 340px))',
          justifyContent: 'start',
          gap: '18px',
        }}
      >
        {combinations.map((combination, index) => (
          <CombinationCard
            key={combination.id}
            combination={combination}
            furniturePieces={furniturePieces}
            isSelected={combination.id === selectedId}
            isFirst={index === 0}
            isLast={index === combinations.length - 1}
            onSelect={() => onSelect(combination.id)}
            onTry={() => onTry(combination.id)}
            onMoveUp={() => onMoveUp(combination.id)}
            onMoveDown={() => onMoveDown(combination.id)}
          />
        ))}
      </Box>
    </Box>
  );
}